export class BooleanUtils {
  static isBoolean(value: unknown): boolean {
    return typeof value === 'boolean';
  }
}
